import React from 'react';

import { PrimaryButton } from '@components/Button/variants';
import IconCircuit from '@components/Images/Rebranding/IconCircuit';
import IconGraph from '@components/Images/Rebranding/IconGraph';
import IconLightbulb from '@components/Images/Rebranding/IconLightbulb';
import IconMoney from '@components/Images/Rebranding/IconMoney';

import ReadershipStatistic, { ReadershipStatisticProps } from './ReadershipStatistic';
import { READERSHIP_STATISTICS } from './constants';

interface PartnersWhoSectionProps {
  scrollPageToTop: () => void;
}

const PartnersWhoSection = ({ scrollPageToTop }: PartnersWhoSectionProps): JSX.Element => (
  <article className="mt-48 flex flex-col items-center border-0 border-t border-solid border-grayscale-beige px-16 pt-48 sm:mx-28 sm:px-0 md:flex-row md:flex-nowrap md:gap-x-112 md:pr-80 lg:mx-0 lg:mt-64 lg:gap-x-[104px] lg:pl-0 lg:pr-28 lg:pt-64">
    <header className="flex flex-row flex-wrap justify-between gap-y-32 sm:justify-start sm:gap-x-64 md:max-w-[400px] md:flex-col md:items-center md:gap-y-48 lg:max-w-[512px]">
      <IconGraph className="w-48 md:order-1 md:w-56" />
      <IconCircuit className="h-36 md:order-2 md:h-56" />
      <IconMoney className="w-20 md:order-4 md:w-40" />
      <IconLightbulb className="h-36 md:order-5 md:h-80" />
      <div className="md:order-3 md:my-56">
        <h2 className="my-0 font-suisse-works text-subheadline-lg sm:text-headline-md">
          Who you’re reaching
        </h2>
        <p className="mb-0 mt-8 font-suisse-neue text-description-lg sm:mt-16 sm:text-body-lg">
          Our subscriber base of startup founders, venture capitalists, and technology decision
          makers is incredibly engaged.
        </p>
        <PrimaryButton
          as="button"
          className="mt-24 hidden md:block"
          onClick={scrollPageToTop}
          data-testid="partners-who-connect-button"
        >
          Connect with our team
        </PrimaryButton>
      </div>
    </header>
    <div className="mt-48 w-full sm:mt-32 md:mt-0 md:max-w-[277px]">
      <dl className="mx-auto flex max-w-[360px] flex-row flex-wrap gap-x-16 gap-y-48 sm:max-w-[594px] sm:gap-80">
        {READERSHIP_STATISTICS.map(
          (props: ReadershipStatisticProps): JSX.Element => (
            <ReadershipStatistic key={props.statistic} {...props} />
          )
        )}
      </dl>
      <PrimaryButton
        as="button"
        className="mx-auto mt-48 block md:hidden"
        onClick={scrollPageToTop}
      >
        Connect with our team
      </PrimaryButton>
    </div>
  </article>
);

export default PartnersWhoSection;
